import * as React from "react";
import Breadcrumbs from "../core/Breadcrumbs";
import * as moment from "moment";
import CommissionCalculatorForm from "./CommissionCalculatorForm";
import ModernCard from "../core/ModernCard";
import { patchCommission, onFileDrop } from "../../libs/commission_calculator";
import { RailsUserContext } from "../../libs/user_context";
import { useContext, useState, useEffect} from "react";
import { compact } from "lodash";
import CommissionConfigViewModal from "./CommissionConfigViewModal";
import Button from "../core/Button";
import { toast } from "../../utils";
import { Link } from "react-router-dom";
import ManagerMonthApproval from "./ManagerMonthApproval";
import EmployeeMonthApproval from "./EmployeeMonthApproval";
import * as Sentry from "@sentry/browser";
import styled from "styled-components";
import CoreDropzone from "../core/CoreDropzone";
import Loader from "../core/Loader";
import Modal from "../core/Modal";
import axios from "axios"
import FileUploader from "../core/FileUploader";
import { jfetch } from "../../utils";

const CommissionInfoSection = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-around;
`;

const CommissionInfoItem = styled.div`
  display: flex;
  width: 49%;
  flex-direction: column;
  padding: 10px;
  border: 1px solid #e6e6e6;
`;

function CommissionMonth({
  commission,
  commissionPromise,
  isManaging = false,
  history,
}) {
  const commissionUser = commission.user;
  const commissionMoment = moment(commission.month);
  const { user: currentUser } = useContext(RailsUserContext);

  const isAdminView =
    currentUser.organization.id !== commissionUser.organization.id;

  const monthString = commissionMoment.format("MMMM YYYY");
  const config = commission.commissionConfig;
  const configName = config.name;
  const createdMoment = moment(commission.createdAt);
  const [viewingConfig, setViewingConfig] = useState(false);

  const userIsSalesManager = currentUser.roles.includes("sales_manager");
  const userIsOwner = currentUser.isOwner;
  const readOnly = !(userIsOwner || userIsSalesManager);

  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false)
  const [files, setFiles] = useState([]);


  useEffect(() => {
    setFiles(commission.files)
  }, [])

  const onFileDrop = async (acceptedFiles: File[]) => {
    const data = new FormData();
    acceptedFiles.forEach(file => data.append("files[]", file));

    return await jfetch
      .post<any>(
        `/commission_calculator/months/${commission.id}/commission_attachment`,
        data
      )
      .then(resp => {
        // this.setState({
        //   prospect_files: resp.prospect.prospect_files_2
        // })
        setFiles(resp.data.attributes.files)
      });
  };    

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   const formData = new FormData();
  //   formData.append("files", uploadedFiles[0]);
  //   axios.post("/month/id/", formData)
  // }


  function makePDF(){
    if (commission.resultCache !== null) {
      setLoading(true)
      axios.get(`https://pdf.chartec.net/pdf.php?url=https://core.chartec.net/commission_calculator/months/${commission.id}?key=DiRedcjfwt3`)
      .then((resp) => {
        window.open(
          resp.data.file,
          "_blank"
        );        
        setLoading(false)
      })

    } else {
      setModalOpen(true);
    }
  }

  return (
    <>
      <Breadcrumbs
        crumbs={compact([
          { label: "Commission Calculator", route: "/", routerLink: true },
          isAdminView
            ? { label: "Admin", route: "/admin", routerLink: true }
            : null,
          isManaging
            ? {
                label: commissionUser.name,
                route: `/salespeople/${commissionUser.id}`,
                routerLink: true,
              }
            : null,
          { label: monthString },
        ])}
      />
      <div className="level">
        <div className="level-left">
          <div className="level-item">
            {isManaging ? (
              <>
                <Link
                  to={`/salespeople/${commissionUser.id}`}
                  className="btn btn-primary"
                >
                  <i className="fa fa-arrow-left" /> Back to Commission List for{" "}
                  {commissionUser.name}
                </Link>
                <div style={{ paddingLeft: "10px" }}>
                  <Link to={`/`} className="btn btn-primary">
                    <i className="fa fa-arrow-left" /> Back to Commission
                    Calculator Homepage
                  </Link>
                </div>
              </>
            ) : (
              <Link to={`/`} className="btn btn-primary">
                <i className="fa fa-arrow-left" /> Back to Your Commissions
              </Link>
            )}
          </div>
        </div>
        <div className="level-right">
          <div className="level-item">
            <Button
              size="xl"
              color={"info"}
              onClick={makePDF}
              loading={loading}
            >
              <i className="fa fa-file-text" /> Export to PDF
            </Button>
          </div>
        </div>
      </div>
      {isManaging ? (
        <ManagerMonthApproval
          commission={commission}
          commissionPromise={commissionPromise}
          history={history}
        />
      ) : (
        <EmployeeMonthApproval
          commission={commission}
          commissionPromise={commissionPromise}
          history={history}
        />
      )}
      <ModernCard title={`Commission for ${monthString}`} ta="left" m="0px">
        <CommissionCalculatorForm
          month={commission}
          onChange={({ values, result }) => {
            patchCommission(commission.id, { ...values, resultCache: result })
              .then(() => {
                toast.success("Month saved.");
              })
              .catch(e => {
                toast.error("Error while saving month.");
                Sentry.captureException(e);
              });
          }}
          readOnly={readOnly || isAdminView}
        />
        <CommissionInfoSection>
          <CommissionInfoItem>
            <>
              {/* <h4>Attachments</h4>
              <table className="table">
                <thead>
                  <tr>
                    <th> File Name </th>
                    <th> Delete </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <a target={"_blank"} href={'/some/file/url.pdf'} rel="noopener noreferrer" >
                        some file name
                      </a>
                    </td>
                    <td>
                      <a>
                        <i className="fa fa-trash" />
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table> */}
              <FileUploader
                onDrop={onFileDrop}
                uploadedFiles={ files || []}
              />    
            </>
          </CommissionInfoItem>
          <CommissionInfoItem>
            <p>
              This commission was created with the{" "}
              {config.archived ? "(now archived)" : ""} &apos;{configName}&apos;
              configuration on{" "}
              {createdMoment.format("ddd, MMMM Do YYYY [@] h:mm:ss a")}.
            </p>
            <p>
              Changes made to the configuration after this time will not be
              applied to this month.
            </p>
            <Button onClick={() => setViewingConfig(true)}>
              <i className="fa fa-eye" /> View Config
            </Button>
          </CommissionInfoItem>
        </CommissionInfoSection>
      </ModernCard>
      <CommissionConfigViewModal
        open={viewingConfig}
        close={() => setViewingConfig(false)}
        config={commission.commissionConfig}
        showVersionInfo={true}
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          padding: "10px 0",
          margin: "10px 0",
          borderTop: "1px solid rgb(204, 213, 217)",
          borderBottom: "1px solid rgb(204, 213, 217)",
        }}
      >
        <Button size="xl" color={"primary"} onClick={() => history.goBack()}>
          Finished
        </Button>
      </div>
      <Modal
        title={"Export Failed"}
        open={modalOpen}
        close={() => setModalOpen(false)}
        submittable={false}
      >
        <div>No data to export!</div>
      </Modal>
    </>
  );
}


export default CommissionMonth;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/CommissionMonth.tsx